module.exports = __webpack_public_path__ + "img/chris-country.c12ae230.png";